import React, { Component } from 'react'
import { Row, Col, Card, Collapse, Button, Icon } from "antd"
import './index.css'
const { Panel } = Collapse
import UseProduct from './UseProduct'

export default class CoreFirm extends Component {
  render() {
    let noticelist = [1,2,3,4,5]
    return (
      <div>
        <Card 
          title={
            <span><Icon type="windows" />
            <span style={{color:'#666',fontSize:'12px',marginLeft:'20px'}}>
              在用产品
            </span>
            </span>
          } 
          bordered={false} 
          style={{boxShadow: '0 0 4px 0 rgb(57 103 153 / 20%)',marginBottom: '20px'}}>
          <UseProduct></UseProduct>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/workbench/CoreFirm/index.js